import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Area, Box, Modal } from '@ublend-npm/aulaui-core';
import { getCurrentSpaceId } from '@core/selectors/space';

import useBreakpoints from '@app/hooks/useBreakpoints';
import pushRoute from '@app/utils/routing';
import InviteParticipants from './InviteParticipants';

interface InviteParticipantsModalProps {
  open: boolean;
  onClose: () => void;
  conversationId?: string;
}

const InviteParticipantsModal = ({
  open,
  onClose,
  conversationId,
}: InviteParticipantsModalProps) => {
  const { lg } = useBreakpoints();
  const spaceId = useSelector(getCurrentSpaceId);

  // This modal should be a separate page if the screen is too small
  // Redirect if open and screen is small
  useEffect(() => {
    if (open && !lg && conversationId) {
      pushRoute(`dashboard/${spaceId}/messages/${conversationId}/invite`);
      onClose();
    }
  }, [open, lg, conversationId, spaceId, onClose]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ width: 'min(1152px, 100dvw)' }}>
        <Area rounded>
          <InviteParticipants
            onClose={onClose}
            conversationId={conversationId}
          />
        </Area>
      </Box>
    </Modal>
  );
};

export default InviteParticipantsModal;
